import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LogoutButton } from 'shared/components/LogoutButton';
import { AuthContext } from 'shared/contexts/AuthContext';
import { useSitemap } from 'shared/hooks/useSitemap';
import { ConnectisPrimaryLogo } from 'shared/icons';
import { LanguageSwitch } from './LanguageSwitch';
import { Menu } from './Menu';
import { NotificationDropdown } from './NotificationDropdown';

export const Navbar = () => {
  const sitemap = useSitemap();
  const { isLogoutAllowed } = useContext(AuthContext);
  return (
    <header className="bg-background fixed inset-x-0 top-0 z-30 border-b border-black/20">
      <div className="max-w-container mx-auto grid grid-cols-[1fr_auto] items-center px-4 md:grid-cols-[auto_1fr_auto] md:gap-8 lg:px-8">
        <Link to={sitemap.dashboard} aria-label="Connectis" className="flex h-[50px] items-center">
          <ConnectisPrimaryLogo className="w-[120px]" />
        </Link>
        <div className="col-span-2 row-start-2 flex h-11 items-center md:col-span-1 md:col-start-2 md:row-start-1 md:h-[50px]">
          <Menu />
        </div>
        <div className="col-start-2 row-start-1 flex items-center gap-2 md:col-start-3">
          <NotificationDropdown />
          <LanguageSwitch />
          {isLogoutAllowed && <LogoutButton />}
        </div>
      </div>
    </header>
  );
};
